/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Button from "../shared-ui//button";
import { GETUSERTNCCONSENTAGREEMENT } from "../../queries/terms";
import queryString from "query-string";
import ResultsHeader from "../shared-ui/results-header";
import Footer from "../shared-ui/footer";
import TermsConditions from "../terms-conditions";
import { getContentFromContentStack } from "../../core/contentStack";
import CartComponent from "../shared-ui/cart";
import { getLinkMetadata } from "../../services/aboToolsService";
import _ from "lodash";
import {
  compareGuestExpiryTime,
  setGuestExpiryTime,
  setGuestSaveResultTime,
} from "../../utils/handleExpiryTime";
import { clearSession } from "../../utils/clearSession";
import { handleGuestExpiryPopup } from "../../utils/handlePopups";
import { validateOktaSession } from "../../utils/validateOktaSession";
import { withOktaAuth } from "@okta/okta-react";
import SaveResultsPopup from "../shared-ui/popup/save-results";
import { handleRecoResultByRecoIdAPI } from "../../services/recommendationService";
import { fetchLynxValueAttribution } from "../../services/commerceServices/attributionServices";
import Cookies from "js-cookie";
import { removeHybrisSession } from "../../services/commerceServices/accessToken";
import { utag, withUtag } from "../analytics/analytics";
import i18n from "../../i18n";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../utils/utagSession";
import PickSurveyComponent from "../achievers";

//import { Helmet } from "react-helmet";
//import { dynatraceConfig, } from "./dynatrace"
// Infterface for WelcomeComponent State

interface WelcomeComponentState {
  isTermsVisible: boolean;
  errorMsg: String;
  landingHomePageContents: any;
  isCartVisible: boolean;
  isSessionExpired: boolean;
  isPopupOpen: boolean;
  isAssessmentDone: boolean;
  isAssessmentContinued: boolean;
  visibleOnMobile: boolean;
  isPickSurveyVisible: boolean;
}

/**
 * welcome Screen component.
 *
 * @namespace WelcomeComponent
 */
class WelcomeComponent extends React.Component<any, WelcomeComponentState> {
  /*componentDidMount() {
    dynatraceConfig();


    if (`${process.env.REACT_APP_ENVIRONMENT}` == "dev") {
      const script = document.createElement("script");
      script.src = "./dynatrace.js";
      script.async = true;
      document.body.appendChild(script);
    }
    else if (`${process.env.REACT_APP_ENVIRONMENT}` == "qa") {
      const script = document.createElement("script");
      script.src = "./dynatrace.js";
      script.async = true;
      document.body.appendChild(script);
    }
    else if (`${process.env.REACT_APP_ENVIRONMENT}` == "prod") {
      const script = document.createElement("script");
      script.src = "./dynatrace.js";
      script.async = true;
      document.body.appendChild(script);
    }
    else {
      const script = document.createElement("script");
      script.src = "./dynatrace.js";
      script.async = true;
      document.body.appendChild(script);
    }

}*/

  constructor(props: any) {
    super(props);
    this.state = {
      isTermsVisible: false,
      errorMsg: "",
      landingHomePageContents: [],
      isCartVisible: false,
      isSessionExpired: false,
      isPopupOpen: false,
      isAssessmentDone: false,
      isAssessmentContinued: false,
      visibleOnMobile: false,
      isPickSurveyVisible: false,
    };

    const { search } = this.props.location;
    const { id } = queryString.parse(search);
    // getLinkMetadata - call only after log in and user should be ABO
    if (!_.isNull(id) && !_.isUndefined(id)) {
      getLinkMetadata(id);
      // const aboMetaData = JSON.parse(localStorage.getItem("aboMetaData") || "[]");
      // if (aboMetaData?.data?.linkId) {
      //   let token = "";
      //   fetchLynxValueAttribution().then((res: any) => {
      //     token = res;
      //     Cookies.set("LynxValueAttribution", token, { domain: ".qa.amway.com" });
      //   });
      // }
    }
  }

  componentDidMount = () => {
    const { search } = this.props.location;
    const { locale } = queryString.parse(search);
    if (!sessionStorage.getItem("languageTypeOfApp")) {
      const localLanguageType =
        (locale === "es-us" && "es-us") ||
        (locale === "en-us" && "en-us") ||
        "en-us";
      sessionStorage.setItem("languageTypeOfApp", localLanguageType);
      i18n.changeLanguage(localLanguageType);
    }

    //update to analytics

    let authObj = getUtagAuthObject();
    let sessionObj = getUtagSessionObject();
    let needStatesObj = getUtagNeedStates();

    let obj = {
      page_name: "Welcome Page",
      event_name: "welcome_details",
    };
    let updatedObj = _.merge(
      localStorage.getItem("user-info") ? authObj : {},
      localStorage.getObj("reco-result") ? needStatesObj : {},
      sessionObj
      // obj
    );
    withUtag().then((utag) => utag.view(updatedObj));
    // if (localStorage.getItem("logout")) {
    //   removeHybrisSession();
    //   localStorage.removeItem("logout");
    // }

    //get user T & C Consent Agreement
    //   if(localStorage.getObj("user-info")) {
    //     let userInfoData = localStorage.getObj("user-info");
    //   this.props.client
    //   .query({
    //     query: GETUSERTNCCONSENTAGREEMENT,
    //     variables: {
    //       partyId: userInfoData?.partyId,
    //     },
    //     fetchPolicy: "no-cache",
    //   })
    //   .then((res: any) => {
    //     console.log("res-->",res)
    //     if(res?.data?.getDataByID?.userConsent) {
    //       localStorage.setObj("user-consent", "accepted");
    //     }
    //   })
    //   .catch((err: any) => {
    //     console.log(err);
    //   });
    // }

    const mediaQuery = window.matchMedia("(max-width: 767px)").matches;
    if (mediaQuery) {
      this.setState({
        visibleOnMobile: true,
      });
    }
    this.getLandingHomePageData("ms_main_home_page");
    this.handleAssesmentDoneButtonText();
    if (
      sessionStorage.getItem("before-login-consent") &&
      !this.state.isTermsVisible &&
      localStorage?.getObj("user-consent") !== "accepted"
    ) {
      this.setState({
        isTermsVisible: true,
      });
    }

    //fetch recommendations using reco-id of existing logged in user
    const reco_id = localStorage.getObj("reco-user-id");
    let foundationalPageCount = sessionStorage.getItem("foundationalPageCount");
    if (
      reco_id &&
      !foundationalPageCount &&
      localStorage.getItem("okta-token-storage")
    ) {
      handleRecoResultByRecoIdAPI(reco_id)
        .then((res: any) => {
          res && localStorage.setObj("reco-result", res);
          res &&
            this.setState({
              isAssessmentDone: true,
            });
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
    //handles guest expiry popup
    handleGuestExpiryPopup(this.props);
  };

  componentWillReceiveProps(props: any) {
    //getContentFormComponenet function is called here
    if (props && props.i18n.language) {
      this.getLandingHomePageData("ms_main_home_page");
    }
  }

  componentDidUpdate = () => {
    validateOktaSession(this.props.oktaAuth);
    if (
      localStorage.getItem("guestExpiryTime") &&
      compareGuestExpiryTime() < 0
    ) {
      clearSession(this.props);
    }
    //enables login session expiry popup
    if (
      sessionStorage.getItem("login-session-expired") &&
      !this.state.isSessionExpired &&
      !(localStorage?.getItem("okta-token-storage") !== "{}")
    ) {
      this.setState({
        isSessionExpired: true,
        isPopupOpen: true,
      });
    }
  };
  /**
   * This method is used to handle continue button
   *
   */

  handleContinue = () => {
    this.props.client
      .query({
        query: GETUSERTNCCONSENTAGREEMENT,
        variables: {
          userId: "5",
        },
        fetchPolicy: "no-cache",
      })
      .then((res: any) => {
        const statusCode =
          res.data &&
          res.data.getUserTncConsentAgreement &&
          res.data.getUserTncConsentAgreement.code;

        const status =
          res.data &&
          res.data.getUserTncConsentAgreement &&
          res.data.getUserTncConsentAgreement.result &&
          res.data.getUserTncConsentAgreement.result[0].status;

        if (statusCode === 200) {
          if (status) {
            this.props.history.push("/foundational");
          } else {
            this.props.history.push("/terms");
          }
        } else {
          this.props.history.push("/terms");
        }
      })
      .catch((err: any) => {
        console.log(err);
        this.props.history.push("/terms");
      });
  };

  handleLearnMore = () => {
    this.props.history.push("/home");
  };

  /**
   * This method is used to handle Survey button
   *
   */
  handleTakeSurvey = () => {
    if (this.state.isAssessmentContinued) {
      //handles continue assessment
      this.props.history.push("/foundational");
    } else if (this.state.isAssessmentDone) {
      this.setState(
        {
          isPickSurveyVisible: false,
        },
        () => {
          const storageData = localStorage.getObj("results");
          // this.props.history.push("/results");
          this.props.history.push("/results", { data: storageData });
        }
      );
    } else {
      this.setState({
        isPickSurveyVisible: true,
      });
    }
    // let userConsentFlag: any = localStorage.getObj("user-consent");
    // if (!this.state.isAssessmentDone) {
    //   // Call for Term and condition
    //   if (userConsentFlag && userConsentFlag === "accepted") {
    //     this.setState({
    //       isTermsVisible: false,
    //     });
    //     this.props.history.push("/foundational");
    //   } else {
    //     this.setState({
    //       isTermsVisible: true,
    //     });
    //   }
    //   // this.props.history.replace("/terms");
    // } else if (this.state.isAssessmentContinued) {
    //   //handles continue assessment
    //   this.props.history.push("/foundational");
    // } else {
    //   // call for the result page.

    //   //sets save result popup time for guest user
    //   if (!localStorage.getItem("okta-token-storage")) {
    //     setGuestSaveResultTime();
    //   }
    //   if (userConsentFlag && userConsentFlag === "accepted") {
    //     const storageData = localStorage.getObj("results");
    //     // this.props.history.push("/results");
    //     this.props.history.push("/results", { data: storageData });
    //   } else {
    //     localStorage.removeItem("reco-result");
    //     this.setState({
    //       isTermsVisible: true,
    //     });
    //   }
    // }
  };

  /**
   * Used for text change for conditional navigation
   * Text = go to result, only if the assesment done
   */
  handleAssesmentDoneButtonText = () => {
    let recoResult = localStorage.getObj("reco-result");
    let foundationalCount = sessionStorage.getItem("foundationalPageCount");
    if (recoResult) {
      this.setState({
        isAssessmentDone: true,
        isAssessmentContinued: false,
      });
    } else if (foundationalCount) {
      this.setState({
        isAssessmentContinued: true,
        isAssessmentDone: false,
      });
    } else {
      this.setState({
        isAssessmentDone: false,
      });
    }
  };

  /**
   * This method is used to handle terms popup close
   *
   */
  handleTermsClose = () => {
    this.setState(
      {
        isTermsVisible: false,
      },
      () => {
        if (sessionStorage.getItem("before-login-consent")) {
          sessionStorage.removeItem("before-login-consent");
        }
      }
    );
  };

  /**
   * This method is used to handle pick survey popup close
   *
   */
  handlePickSurveyClose = () => {
    this.setState({
      isPickSurveyVisible: false,
    });
  };

  handleCartClick = (e?: any) => {
    this.setState({
      isCartVisible: true,
    });
  };
  handleCartKeyPress = (e: any) => {
    if (e.key === "Enter") {
      this.handleCartClick();
    }
  };

  handleCartClose = () => {
    this.setState({
      isCartVisible: false,
    });
  };

  handleAssessmentClick = (value: boolean) => {
    // if (value) {
    //   this.setState({
    //     isTermsVisible: true,
    //   });
    // } else {
    //   this.setState(
    //     {
    //       isTermsVisible: false,
    //     },
    //     () => {
    //       this.props.history.push("/foundational");
    //     }
    //   );
    // }
    // let recoResult = localStorage.getObj("reco-result");
    // if (recoResult && !_.isEmpty(recoResult?.data?.getRecommendation)) {
    //   this.setState({
    //     isAssessmentDone: true,
    //   });
    // } else {
    //   this.setState({
    //     isAssessmentDone: false,
    //   });
    // }
    // this.setState({
    //   isCartVisible: true,
    // });
  };

  /**
   * This method is used to get content from content stack
   * @param {string} contentTypeId
   *
   */
  getContentForComponent = (contentTypeId: string) => {
    return getContentFromContentStack(contentTypeId)
      .then((response) => {
        if (response && response.error_message) {
          this.setState({
            errorMsg: response,
          });
        } else {
          return response && response[0];
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * This method is used to get Landing home page data from content stack
   * @param {string} contentTypeId
   *
   */
  getLandingHomePageData = async (contentTypeId: any) => {
    let result: any;
    result = await this.getContentForComponent(contentTypeId);

    let Obj: any = {};
    Obj.content = result && result[0];

    this.setState({
      landingHomePageContents: [Obj],
    });
  };

  closePopup = () => {
    this.setState(
      {
        isPopupOpen: false,
      },
      () => {
        // sessionStorage.setItem("saveResults", "false");
        // sessionStorage.removeItem("login-session-expired")
        //if user denied to relogin then session gets cleared
        if (sessionStorage.getItem("login-session-expired")) {
          let currentLanguage =
            sessionStorage.getItem("languageTypeOfApp") || "en-us";
          localStorage.clear();
          sessionStorage.clear();
          sessionStorage.setItem("languageTypeOfApp", currentLanguage);
          this.props.history.push("/home");
          localStorage.setItem("logout", "true");
        }
      }
    );
  };

  handleSelectSurvey = (surveyType: any) => {
    localStorage.setItem("surveyType", surveyType);
    this.setState({
      isPickSurveyVisible: false,
    });
    let userConsentFlag: any = localStorage.getObj("user-consent");
    if (!this.state.isAssessmentDone) {
      // Call for Term and condition
      if (userConsentFlag && userConsentFlag === "accepted") {
        this.setState({
          isTermsVisible: false,
        });
        this.props.history.push("/foundational");
      } else {
        this.setState({
          isTermsVisible: true,
        });
      }
      // this.props.history.replace("/terms");
    } else if (this.state.isAssessmentContinued) {
      //handles continue assessment
      this.props.history.push("/foundational");
    } else {
      // call for the result page.

      //sets save result popup time for guest user
      if (!localStorage.getItem("okta-token-storage")) {
        setGuestSaveResultTime();
      }
      if (userConsentFlag && userConsentFlag === "accepted") {
        const storageData = localStorage.getObj("results");
        // this.props.history.push("/results");
        this.props.history.push("/results", { data: storageData });
      } else {
        localStorage.removeItem("reco-result");
        this.setState({
          isTermsVisible: true,
        });
      }
    }
  };

  render() {
    const {
      landingHomePageContents,
      isCartVisible,
      isAssessmentDone,
      isAssessmentContinued,
      visibleOnMobile,
    } = this.state;

    const { home_title, home_subtitle } =
      (landingHomePageContents &&
        landingHomePageContents[0] &&
        landingHomePageContents[0].content) ||
      {};

    let isConsentAccepted = localStorage.getItem("user-consent");
    return (
      <div className="welcome-screen-container">
        {/* Focus Path Start */}
        {this.state.isPickSurveyVisible && (
          <PickSurveyComponent
            {...this.props}
            show={this.state.isPickSurveyVisible}
            handleClose={this.handlePickSurveyClose}
            handleSelectSurvey={(surveyType: any) =>
              this.handleSelectSurvey(surveyType)
            }
          />
        )}
        {/* Focus Path Ends */}

        {/* Terms & Condition Start */}
        <TermsConditions
          {...this.props}
          show={this.state.isTermsVisible}
          handleClose={this.handleTermsClose}
        />
        {/* Terms & Condition Ends */}

        {/* Cart Component Start */}
        {isCartVisible ? (
          <CartComponent
            {...this.props}
            handleClose={this.handleCartClose}
            show={isCartVisible}
          />
        ) : null}
        {/* Cart Component Ends */}

        {/* header contaiiner Start */}
        <div className="header-container">
          <ResultsHeader
            {...this.props}
            handleAssessmentClick={this.handleTakeSurvey}
            handleCartClick={this.handleCartClick}
            handleCartKeyPress={(e: any) => {
              if (e.key === "Enter" || e.key === " ") {
                this.handleCartClick(e);
              }
            }}
          />
        </div>
        {/* header contaiiner Ends */}

        {this.state.isSessionExpired && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.welcome_back")}
            popupMessage={this.props.t("common.login_session_expiry_message")}
            popupFirstButton={this.props.t("common.sign_in")}
            popupFirstButtonType="sign-in"
            // popupSecondButton="Take the Quiz"
          />
        )}

        {/* middle area Start */}
        <div className="middle-area">
          <div
            className="welcome-screen-wrapper"
            style={{
              backgroundImage: visibleOnMobile
                ? `radial-gradient(141.8% 148.51% at 0% 0%, #FFFFFF 40.41%, rgba(255, 255, 255, 0.5) 55.07%, rgba(255, 255, 255, 0) 63.02%
              ),url(${process.env.REACT_APP_MB_HOME_LANDING})`
                : `radial-gradient(46.86% 140.74% at 0% 0%, #FFFFFF 59.31%, rgba(255, 255, 255, 0.511438) 86.73%, rgba(255, 255, 255, 0) 99.77%),url(${process.env.REACT_APP_HOME_LANDING})`,
            }}
            // style={{
            //   backgroundImage: `url(${process.env.REACT_APP_HOME_LANDING})`,
            // }}
          >
            <div className="title-wrapper">
              <div role="heading" aria-level={1} className="heading">
                {home_title}
              </div>
              <div className="sub-title">{home_subtitle}</div>
            </div>
            <div className="learn-more-wrapper">
              <div className="take-survey-btn">
                <Button
                  name={
                    isAssessmentContinued &&
                    !isAssessmentDone &&
                    isConsentAccepted
                      ? this.props.t("common.keep_going")
                      : isAssessmentDone && isConsentAccepted
                      ? this.props.t("common.go_to_my_result")
                      : this.props.t("common.start_the_assessment")
                  }
                  className="app-btn"
                  onButtonClick={this.handleTakeSurvey}
                />
              </div>
              <div className="want-to-learn">
                {this.props.t("common.want_to")}{" "}
                <span
                  className="link"
                  role="link"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.handleLearnMore();
                    }
                  }}
                  onClick={this.handleLearnMore}
                >
                  {this.props.t("common.learn_more_home")}
                </span>{" "}
                {this.props.t("common.before_you_get_started")}
              </div>
            </div>
          </div>
        </div>
        {/* middle area Ends */}
        {/* Footer Section Start */}
        <Footer {...this.props} />
        {/* Footer Section Ends */}
      </div>
    );
  }
}

export default withOktaAuth(WelcomeComponent);
